import React from "react";

type PaymentSelectGroupProps = {
  placeholder: string;
  name: string;
  value: string;
  onChange: React.ChangeEventHandler<HTMLSelectElement>;
  options: { value: string; label: string }[];
  required?: boolean;
};

/** Labeled dropdown styled to match PaymentInputGroup fields. */
const PaymentSelectGroup = ({
  placeholder,
  name,
  value,
  onChange,
  options,
  required = false,
}: PaymentSelectGroupProps) => {
  return (
    <div className="payment-input-group flex-1">
      <label className="payment-label">
        {placeholder} {required && <label className="text-red-500">*</label>}
      </label>
      <select
        name={name}
        value={value}
        onChange={onChange}
        className="payment-input-field bg-white"
        required={required}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default PaymentSelectGroup;
